import {Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";
import {useSelector} from "react-redux";
import TooltipInfo from "../TooltipInfo.jsx";
import React from "react";

export const PieChartAnaliza = ({
                                    data, dataKey, title, fill, selectors, hideExelExport = false,
                                    hideCopyToclipboard = false, tooltipKey,
                                }) => {

    const tooltipHtml = useSelector(state =>
        state.chartTooltips.msg[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div>
                        {!!selectors && selectors()}
                    </div>
                    <div>
                        {(!hideExelExport && data) &&
                            <ExportToExcel
                                data={data}
                                fileName={title || 'analiza'}
                            />
                        }
                        {(!hideCopyToclipboard && data) &&
                            <CopyDataToClipboard data={data}/>
                        }
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart

                        width={400} height={400}>
                        <Tooltip/>
                        {/*<Pie data={data} dataKey={dataKey} cx="50%" cy="50%" innerRadius={100} outerRadius={130} fill="#82ca9d" label />*/}
                        <Pie
                            startAngle={180}

                            endAngle={0}
                            data={data}
                            dataKey={dataKey} cx="50%" cy="85%" outerRadius={200}
                            fill={fill ?? "#8884d8"}
                            label
                        />
                    </PieChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )
}

PieChartAnaliza.propTypes = {
    data: PropTypes.array.isRequired,
    dataKey: PropTypes.string.isRequired,
    fill: PropTypes.string,
    title: PropTypes.string,
    selectors: PropTypes.func,
    hideExelExport: PropTypes.bool,
    hideCopyToclipboard: PropTypes.bool,
    tooltipKey: PropTypes.string,
}
